import { Flex, Statistic } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { formatDate } from 'shared/utils/time/format-date.ts';
import { StatisticMoney } from 'components/common/statistic-money/statistic-money';
import { ExpenseEdit } from 'components/expenses/expense-edit';
import { ExpenseStatusEdit } from 'components/expenses/expense-status-edit';
import { ExpenseStatusTag } from 'components/expenses/expense-status-tag';
import styles from './expense-page-header.module.scss';
import type { IExpensePageHeaderProps } from './types';

export const ExpensePageHeader = (props: IExpensePageHeaderProps) => {
  const { expense } = props;

  return (
    <PageHeader
      title={`Expense #${expense.id}`}
      tags={[<ExpenseStatusTag key='status' status={expense.status} />]}
      extra={[
        <ExpenseStatusEdit key='status-edit' expenseId={expense.id} currentStatus={expense.status} />,
        <ExpenseEdit key='edit' expense={expense} />,
      ]}
      onBack={() => history.back()}>
      <div className={styles.statisticsBox}>
        <Flex gap='large'>
          {expense.clientNumber ? (
            <Statistic title='Client number' value={expense.clientNumber} groupSeparator='' />
          ) : null}
          <Statistic title='Type' value={expense.type?.name} />
          <Statistic className={styles.dateStat} title='End date' value={formatDate(expense.endDate)} />
          <StatisticMoney
            title='Price'
            currency={expense.currency}
            value={expense.price}
            valueInDefault={expense.priceInDefault}
          />
        </Flex>
      </div>
    </PageHeader>
  );
};
